module.exports = "/images/manager-settings-icon.svg?93862743d59ef62456a4dd84eb70bfca";